module.exports = __webpack_public_path__ + "static/media/upload.f4e341b9.svg";